import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import { bgImage } from './../../scripts';
import Press from './../Press';
import Awards from './Awards';
import ItunesButton from './ItunesButton';
import { heights, widths, spacing, colors, fonts, breakpoints } from './../../styles/theme.json';

const FilmProjectInfo = (props) => {
    let Information = false;
    if (props.ProjectInfo.information_sections) {
      Information = props.ProjectInfo.information_sections.map((item, i) =>
        <div className={'information-section'} key={'info-' + i}>
          <h3 className={'small-header'}>{item.title}</h3>
          <div className={'film-detail-markup'} dangerouslySetInnerHTML={{ __html:item.content}}/>
          <style jsx>{`
            .information-section {
              margin-bottom: 5rem;
            }
            .information-section:last-child {
              margin-bottom: 0;
            }
          `}</style>
        </div>
      );
    };
    return (
      <article id={'film-info'}>
        <div className={'row'}>
          <div className={'content-left'}>
            <div className={'content-left-wrapper'}>
              <h3 className={'small-header'}>{props.ProjectInfo.video_date}</h3>
              <div className={'film-top-item formatted-markup'} dangerouslySetInnerHTML={{ __html:props.ProjectInfo.content}}/>
              {(props.ProjectInfo.press && props.window_width >= breakpoints.desktop) &&
                <div className={'film-top-item'}>
                  <Press PressData={props.ProjectInfo.press} />
                </div>
              }
              {(props.ProjectInfo.itunes_link && props.window_width >= breakpoints.desktop) &&
                <ItunesButton ItunesLink={props.ProjectInfo.itunes_link} />
              }
            </div>
          </div>
          {(Information) &&
            <div className={'content-right'}>
              {Information}
              {(props.ProjectInfo.press && props.window_width < breakpoints.desktop) &&
                <div className={'film-top-item'}>
                  <Press PressData={props.ProjectInfo.press} />
                </div>
              }
              {(props.ProjectInfo.awards) &&
                <Awards AwardsData={props.ProjectInfo.awards} />
              }
              {(props.ProjectInfo.itunes_link && props.window_width < breakpoints.desktop) &&
                <ItunesButton ItunesLink={props.ProjectInfo.itunes_link} />
              }
            </div>
        }
        </div>
      <style jsx>{`
        #film-info {
          width: 100%;
          max-width: ${widths.global_max_width};
          margin-bottom: 3rem;
          display: flex;
          flex-direction: column;
        }
        .row {
          display: flex;
          flex-direction: column;
        }
        .row:first-child {
          margin-bottom: 5rem;
        }
        .content-left {
          width: 100%;
        }
        .content-left-wrapper {
          width: 100%;
          margin-bottom: 5rem;
        }
        .content-right {
          width: 100%;
        }
        .awards-mobile {
          margin-top: 3rem;
        }
        .film-top-item {
          margin-bottom: 5rem;
        }
        @media (min-width: 640px) {
          .content-left {
            width: calc((100% / 3) * 2);
            padding-right: 3rem;
          }
          .content-left-wrapper {
            margin-bottom: 0;
          }
          .content-right {
            width: calc(100% / 3);
          }
          .row {
            flex-direction: row;
          }
          .row:first-child {
            margin-bottom: 5rem;
          }
          .content-left {
            padding-right: 3rem;
          }
        }
      `}</style>
    </article>
  );
};

export default connect(
  state => ({
    window_width: state.window_dimensions.window_width
  })
)(FilmProjectInfo);



// WEBPACK FOOTER //
// ./src/components/photo-film-project/FilmProjectInfo.js